import React from 'react';
import { GithubIcon, LockIcon, ExternalLinkIcon, FileTextIcon } from 'lucide-react';
interface ProjectCardProps {
  title: string;
  client?: string;
  description: string;
  image: string;
  githubUrl?: string;
  availableByRequest?: boolean;
  slideUrl?: string;
  liveAppUrl?: string;
  docUrl?: string;
  imagePosition?: 'left' | 'right';
}
export function ProjectCard({
  title,
  client,
  description,
  image,
  githubUrl,
  availableByRequest,
  slideUrl,
  liveAppUrl,
  docUrl,
  imagePosition = 'left'
}: ProjectCardProps) {
  return <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow" data-id="element-20">
      <div className={`flex flex-col ${imagePosition === 'right' ? 'md:flex-row-reverse' : 'md:flex-row'}`} data-id="element-21">
        <div className="w-full md:w-1/2 bg-gray-50 flex items-center justify-center p-4" data-id="element-22">
          <img src={image} alt={title} className="w-full h-auto max-h-96 object-contain" data-id="element-23" />
        </div>
        <div className="p-8 flex-1" data-id="element-24">
          <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-25">{title}</h3>
          {client && <p className="text-sm text-blue-600 font-medium mb-3" data-id="element-26">{client}</p>}
          <p className="text-gray-600 mb-6 leading-relaxed text-lg" data-id="element-27">
            {description}
          </p>
          <div className="flex flex-wrap gap-3" data-id="element-28">
            {githubUrl && <a href={githubUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-5 py-2.5 bg-gray-900 text-white rounded-md hover:bg-gray-800 transition-colors" data-id="element-29">
                <GithubIcon size={18} data-id="element-30" />
                View on GitHub
              </a>}
            {slideUrl && <a href={slideUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-31">
                <ExternalLinkIcon size={18} data-id="element-32" />
                Open Slides
              </a>}
            {docUrl && <a href={docUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-33">
                <FileTextIcon size={18} data-id="element-34" />
                Open Doc
              </a>}
            {liveAppUrl && <a href={liveAppUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-5 py-2.5 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors" data-id="element-35">
                <ExternalLinkIcon size={18} data-id="element-36" />
                View Live App
              </a>}
            {availableByRequest && <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-gray-100 text-gray-600 rounded-md" data-id="element-37">
                <LockIcon size={18} data-id="element-38" />
                Available by Request
              </div>}
          </div>
        </div>
      </div>
    </div>;
}